export const ROLE_FORMATEUR_MYSHIFT2 = 'ROLE_FORMATEUR_MYSHIFT2';
export const ROLE_COORDI_FORMATION_MYSHIFT2 = 'ROLE_COORDI_FORMATION_MYSHIFT2';
export const ROLE_MANAGER_QUALITE = 'ROLE_MANAGER_QUALITE';


// WEBPACK FOOTER //
// ./src/app/model/commons/RoleConstants.ts